function createScrollSideEffect() {
    return function (_a) {
        var response = _a.response, navigation = _a.navigation;
        if (navigation.action === "POP") {
            return;
        }
        // we want to wait to scroll until after the re-render,
        // so we use setTimeout to push this onto the event loop
        setTimeout(function () {
            var hash = response.location.hash;
            if (hash !== "") {
                var element = document.getElementById(hash);
                if (element && element.scrollIntoView) {
                    element.scrollIntoView();
                    return;
                }
            }
            // if there is no hash, no element matching the hash,
            // or the browser doesn't support, we will just scroll
            // to the top of the page
            window.scrollTo(0, 0);
        }, 0);
    };
}

export default createScrollSideEffect;



// WEBPACK FOOTER //
// ./node_modules/@curi/side-effect-scroll/dist/curi-side-effect-scroll.es.js